import { ENVIRONMENTS } from '../../services/exports/Constants';
import useStorefront from '../storefront/useStorefront';

const usePageHeader = () => {
  const { isStorefront } = useStorefront();
  const showEnvBanner: boolean = import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD;
  const bannerHeight = showEnvBanner ? 25 : 0;
  const headerHeight = {
    desktop: isStorefront ? 60 : 70,
  };

  const pageHeaderHeight = {
    desktop: headerHeight.desktop + bannerHeight,
  };

  return {
    showEnvBanner,
    headerHeight,
    pageHeaderHeight,
  };
};

export default usePageHeader;
